import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { quickNews } from '@/mocks/home';

const tagStyles: Record<string, string> = {
  速报: 'bg-primary-100 text-primary-800',
  打包: 'bg-accent-100 text-accent-900',
  热帖: 'bg-secondary-100 text-secondary-900',
  精选: 'bg-secondary-100 text-secondary-900',
  公告: 'bg-background-200 text-foreground-700',
};

export default function NewsFeed() {
  return (
    <section id="feed" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="实时更新"
          icon="ri-flashlight-line"
          title="快讯爆料 · 时间线速览"
          desc="把新入库的合集、打包与社区动静按时间串成一条线，从上往下读一遍，今天的瓜就吃明白了。"
          action="查看更多快讯"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <ol className="relative">
            {quickNews.map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <li className="relative grid grid-cols-1 gap-3 pb-8 md:grid-cols-[92px_1fr] md:gap-6">
                  <div className="hidden pt-1 text-right md:block">
                    <span className="font-heading text-xl font-bold text-foreground-900">{item.time}</span>
                    <span className="mt-0.5 block text-xs text-foreground-400">今天</span>
                  </div>

                  <div className="relative border-l border-background-300 pl-5 md:pl-7">
                    <span className="absolute -left-[5px] top-2 h-2.5 w-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></span>

                    <div className="flex flex-col gap-4 sm:flex-row">
                      <div className="flex-1">
                        <div className="mb-2 flex flex-wrap items-center gap-2">
                          <span
                            className={`rounded-md px-2 py-0.5 text-xs font-medium ${
                              tagStyles[item.tag] || 'bg-background-200 text-foreground-700'
                            }`}
                          >
                            {item.tag}
                          </span>
                          <span className="text-xs text-foreground-400 md:hidden">{item.time} · 今天</span>
                        </div>
                        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                        <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                          <span className="flex items-center gap-1.5">
                            <span className="flex h-3.5 w-3.5 items-center justify-center">
                              <i className="ri-fire-line text-[13px] text-primary-500"></i>
                            </span>
                            热度 {item.heat.toLocaleString()}
                          </span>
                          <span className="flex items-center gap-1.5">
                            <span className="flex h-3.5 w-3.5 items-center justify-center">
                              <i className="ri-chat-3-line text-[13px]"></i>
                            </span>
                            {item.comments} 条讨论
                          </span>
                          <span className="flex cursor-pointer items-center gap-1.5 text-secondary-700 hover:text-secondary-900">
                            <span className="flex h-3.5 w-3.5 items-center justify-center">
                              <i className="ri-arrow-right-up-line text-[13px]"></i>
                            </span>
                            顺线查看
                          </span>
                        </div>
                      </div>

                      {item.thumb ? (
                        <div className="h-28 w-full shrink-0 overflow-hidden rounded-lg sm:h-24 sm:w-36">
                          <img
                            src={item.thumb}
                            alt={`${item.title} 配图`}
                            title={`${item.title} · 爱黑料网`}
                            className="h-full w-full object-cover object-top"
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </li>
              </Reveal>
            ))}
            <li className="grid grid-cols-1 md:grid-cols-[92px_1fr] md:gap-6">
              <div className="hidden md:block"></div>
              <div className="border-l border-transparent pl-5 md:pl-7">
                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  加载更早的速报
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-down-line text-sm"></i>
                  </span>
                </button>
              </div>
            </li>
          </ol>

          <aside className="flex flex-col gap-4 lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-time-line text-base text-primary-500"></i>
                  </span>
                  更新时间轴
                </h3>
                <ul className="mt-4 space-y-3">
                  {[
                    { t: '10:42', d: '合集新增' },
                    { t: '09:58', d: '打包上线' },
                    { t: '09:21', d: '热帖爆发' },
                    { t: '08:47', d: '精选改版' },
                  ].map((row) => (
                    <li
                      key={row.t}
                      className="flex items-center justify-between rounded-md bg-background-50 px-3 py-2.5 text-sm"
                    >
                      <span className="flex items-center gap-2 text-foreground-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-secondary-500"></span>
                        {row.d}
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-900">{row.t}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={100}>
              <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">还没找到想要的？</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  直接翻资源库总目录，按更新时间倒序排列，比一页页翻要快得多。
                </p>
                <button
                  type="button"
                  className="mt-4 flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-folder-open-line text-sm"></i>
                  </span>
                  打开资源库总目录
                </button>
              </div>
            </Reveal>
          </aside>
        </div>
      </div>
    </section>
  );
}